import * as R from 'ramda';
import sportsApi from '../../utils/sportsApi';

const sendPasswordRecoveryEmail = store => async (state, email) => {
    let error = null;

    const loadingState = R.assoc('isRequestingLink', true, state.user);
    store.setState({ user: loadingState });

    const payload = {
        action: 'emailMvcUserPasswordResetLink',
        domainObject: {
            email,
        },
    };

    await sportsApi
        .url('/users')
        .post(payload)
        .badRequest(e => {
            error = JSON.parse(e.message);
        })
        .forbidden(e => {
            error = {
                ...JSON.parse(e.message),
                message:
                    'We are unable to send you a password reset email as you can only access ' +
                    'MVC by connecting through your company’s Single Sign On (SSO) provider.',
            };
        })
        .res();

    store.setState({
        user: {
            ...store.getState().user,
            isRequestingLink: false,
            error,
        },
    });
};

export default sendPasswordRecoveryEmail;
